import React from "react";

import { Component } from "preact";

import styles from "./TopCategories.scss";

const professional = require("../../../assets/categories/ic_professional.svg");
const artMusic = require("../../../assets/categories/ic_artMusic.svg");
const community = require("../../../assets/categories/ic_community.svg");
const foodDrink = require("../../../assets/categories/ic_foodDrink.svg");
const lifestyle = require("../../../assets/categories/ic_lifestyle.svg");
const sportsFitness = require("../../../assets/categories/ic_sportsFitness.svg");

const CategoryBlock = ({ title, image, link = "#" }) => (
  <a href={link} aria-label={`${title} category link`}>
    <div className={styles.block} style={{ backgroundImage: `url(${image})` }}>
      <h3 className={styles.subHeading}>{title}</h3>
    </div>
  </a>
);

const TopCategories = ({}) => (
  <div className={styles.content}>
    <h2 className={styles.heading}>Top Categories</h2>
    <div className={styles.wrapper}>
      <CategoryBlock title="Professional" image={professional} />
      <CategoryBlock title="Food & Drink" image={foodDrink} />
      <CategoryBlock title="Community" image={community} />
      <CategoryBlock title="Arts & Music" image={artMusic} />
      <CategoryBlock title="Sports & Fitness" image={sportsFitness} />
      <CategoryBlock title="Lifestyle" image={lifestyle} />
    </div>
  </div>
);

export default TopCategories;
